module.exports = __webpack_public_path__ + "img/xxhg.db9810bb.png";